/** Fechas y horas con dayjs (plugins utc y timezone): formatos centralizados y helpers de parseo/formateo. */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const FORMATO_HORA = "HH:mm";
export const FORMATO_FECHA = "DD/MM/YYYY";
export const FORMATO_FECHA_HORA = "DD/MM/YYYY HH:mm";
export const FORMATO_ANIO = "YYYY";

/** Formatea una fecha con `format` (por defecto `DD/MM/YYYY HH:mm`); vacío si la fecha no es válida. */
export const parseDate = (date: string | Date | null | undefined, format?: string): string => {
  if (!date) return "";
  const d = dayjs(date);
  if (!d.isValid()) return "";
  return format ? d.format(format) : d.format(FORMATO_FECHA_HORA);
};

/** Fecha y hora en `DD/MM/YYYY HH:mm`; vacío si la fecha no es válida. */
export const formatFechaHora = (date: string | Date | null | undefined): string =>
  parseDate(date, FORMATO_FECHA_HORA);

export default parseDate;
